export default "__VITE_ASSET__2y0h243U__"